


































































































































































































































































import { ActivationType, DiceRoller } from '@/class'
import Vue from 'vue'
import ActionDetailExpander from '../../components/_ActionDetailExpander.vue'
import ActionTitlebar from '../../components/_ActionTitlebar.vue'

export default Vue.extend({
  name: 'invade-dialog',
  components: { ActionDetailExpander, ActionTitlebar },
  props: {
    mech: {
      type: Object,
      required: true,
    },
    action: {
      type: Object,
      required: true,
    },
    fulltech: { type: Boolean },
  },
  data: () => ({
    dialog: false,
    selected: null,
    accuracy: 0,
    difficulty: 0,
    attackRoll: '',
    attackRollString: '',
    rollResultString: '',
    rollAccuracyResults: '[]',
    succeeded: false,
    failed: false,
    complete: false,
    actionCost: false,
    actionFree: false,
    timer: 0,
    finished: false,
  }),
  computed: {
    state() {
      return this.mech.Pilot.State
    },
    actions() {
      return this.state.TechActions.filter(x => x.Activation === ActivationType.Invade)
    },
    rollResultTooltip() {
      let str = this.attackRollString
      if (this.rollResultString) {
        str += `<div class="overline my-n2">Last Roll:</div><div class="caption ml-3">${this.rollResultString}`
        if (this.rollAccuracyResults.length)
          str += ` <span class="subtle--text">[${this.rollAccuracyResults.join(', ')}]</span>`
        str += '</div>'
      }
      return str
    },
    skLog() {
      let l = ['UPLINK ESTABLISHED. ATTEMPTING REMOTE ACCESS.']
      if (this.succeeded) {
        l.push('SYSTEM INVASION SUCCESSFUL.')
        l = l.concat(this.selected.Log)
      } else l.push('ACCESS DENIED. INVASION FAILURE RECORDED.')
      return l
    },
    round() {
      return this.state.Round
    },
  },
  watch: {
    round: {
      immediate: true,
      deep: true,
      handler: function() {
        this.reset()
      },
    },
  },
  methods: {
    runTimeout() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      const timer = setInterval(function() {
        self.timer++

        if (self.timer > self.skLog.length * 10) {
          clearInterval(timer)
          self.finished = true
        }
      }, 80)
    },
    select(a) {
      if (this.fulltech) {
        this.$emit('add-invade', a)
        this.init()
        this.hide()
      }
      this.state.CommitAction(this.action, this.actionFree)
      this.$emit('use')
      this.selected = a
      this.runTimeout()
    },
    fail() {
      if (this.fulltech) {
        this.$emit('add-fail')
        this.init()
        this.hide()
      }
      this.failed = true
      this.state.CommitAction(this.action, this.actionFree)
      this.$emit('use')
      this.runTimeout()
    },
    rollSkill(): void {
      const roll = DiceRoller.rollToHit(this.mech.TechAttack, this.accuracy, this.difficulty)
      this.rollResultString = `${roll.rawDieRoll} + ${roll.staticBonus}`
      if (roll.accuracyResult) {
        this.rollResultString += ` ${roll.accuracyResult > 0 ? '+' : '-'} ${Math.abs(
          roll.accuracyResult
        )}`
      }
      this.rollAccuracyResults = roll.rawAccuracyRolls
      this.attackRoll = roll.total
    },
    undo() {
      this.state.Undo(this.action, this.actionFree)
      this.reset()
    },
    reset() {
      this.$emit('undo')
      this.init()
    },
    init() {
      this.accuracy = 0
      this.difficulty = 0
      this.attackRoll = ''
      this.attackRollString = ''
      this.rollResultString = ''
      this.rollAccuracyResults = '[]'
      this.succeeded = false
      this.failed = false
      this.complete = false
      this.actionCost = false
      this.actionFree = false
      this.timer = 0
      this.finished = false
      this.selected = null
    },
    show(): void {
      this.dialog = true
    },
    hide(): void {
      this.init()
      this.dialog = false
    },
  },
})
